// https://qiita.com/mimoe/items/855c112625d39b066c9a
const hiraToKana = (str) =>
  str.replace(/[\u3041-\u3096]/g, function (match) {
    var chr = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(chr);
  });

// target内部の
// ひらがなの文字列aをひらがなの文字列bに置き換える
// カタカナにした文字列aをカタカナにした文字列bに置き換える
const replace = (target, a, b) => {
  let retStr = target;
  retStr = retStr.replace(new RegExp(a, "gm"), b, "gm");
  retStr = retStr.replace(new RegExp(hiraToKana(a), "gm"), hiraToKana(b), "gm");
  return retStr;
};

export const convertToButatanLang = (japanese) => {
  const convertTableList = [
    // ゃ行変換
    [
      ["きゃ", "か"],
      ["きゅ", "く"],
      ["きょ", "こ"],
      ["ぎゃ", "が"],
      ["ぎゅ", "ぐ"],
      ["ぎょ", "ご"],
      ["しゃ", "さ"],
      ["しゅ", "す"],
      ["しょ", "そ"],
      ["じゃ", "ざ"],
      ["じゅ", "ず"],
      ["じょ", "ぞ"],
      ["ちゃ", "た"],
      ["ちゅ", "つ"],
      ["ちょ", "と"],
      ["ぢゃ", "だ"],
      ["ぢゅ", "づ"],
      ["ぢょ", "ど"],
      ["にゃ", "な"],
      ["にゅ", "ぬ"],
      ["にょ", "の"],
      ["ひゃ", "は"],
      ["ひゅ", "ふ"],
      ["ひょ", "ほ"],
      ["びゃ", "ば"],
      ["びゅ", "ぶ"],
      ["びょ", "ぼ"],
      ["ぴゃ", "ぱ"],
      ["ぴゅ", "ぷ"],
      ["ぴょ", "ぽ"],
      ["みゃ", "ま"],
      ["みゅ", "む"],
      ["みょ", "も"],
      ["りゃ", "ら"],
      ["りゅ", "る"],
      ["りょ", "ろ"],
    ],
    // さ行変換
    [
      ["さ", "た"],
      ["し", "ち"],
      ["す", "つ"],
      ["せ", "て"],
      ["と", "と"],
      ["ざ", "だ"],
      ["じ", "ぢ"],
      ["ず", "づ"],
      ["ぜ", "で"],
      ["ぞ", "ど"],
    ],
    // や行変換
    [
      ["や", "あ"],
      ["ゆ", "う"],
      ["よ", "お"],
    ],
    // ら行変換
    [
      ["ら", "あ"],
      ["り", "い"],
      ["る", "う"],
      ["れ", "え"],
      ["ろ", "お"],
    ],
    // 母音のiをeに (た行を除く)
    [
      ["い", "え"],
      ["き", "け"],
      ["し", "せ"],
      // ["ち", "て"],
      ["に", "ね"],
      ["ひ", "へ"],
      ["み", "め"],
      ["り", "れ"],
      ["ぎ", "げ"],
      ["じ", "ぜ"],
      ["ぢ", "で"],
      ["び", "べ"],
      ["ぴ", "ぺ"],
    ],
    // た行変換
    [
      // ["た", "た"],
      ["ち", "てぃ"],
      ["つ", "とぅ"],
      // ["て", "て"],
      // ["と", "と"],
      // ["だ", "だ"],
      ["ぢ", "でぃ"],
      ["づ", "どぅ"],
      // ["で", "で],
      // ["ど", "ど"],
    ],
  ];

  let retStr = japanese;
  convertTableList.forEach((convertTable) => {
    convertTable.forEach((convertRow) => {
      retStr = replace(retStr, convertRow[0], convertRow[1]);
    });
  });

  return retStr;
};
